"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropTheHammerAbilityHandler = exports.DropTheHammerActorAbilityFactory = exports.DropTheHammerAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Random_1 = require("../../utils/Random");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const enums_1 = require("../../core/enums");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DropTheHammerAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DropTheHammer;
        this.__typeName = "DropTheHammer";
    }
}
exports.DropTheHammerAbilityArgs = DropTheHammerAbilityArgs;
const mkHammerArgs = (_sequence, container, ability) => {
    const invoker = container.getActor(ability.invokerId);
    return new ActorArgs_1.NpcActorArgs(container.getFaction(ability.invokerId), ActorType_1.ActorType.Hammer, container.getLevel(ability.invokerId), Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
        const multiplier = 1;
        pet[key] = Math.round(value * multiplier);
        return pet;
    }, {}), {
        [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("ItsHammerTime").mk()
    })
        .withPlayerId(invoker.playerId)
        .withAi("BasicV2", {
        abilityPriorities: [
            {
                slot: enums_1.AbilitySlot.Ability1,
                target: "random"
            }
        ]
    });
};
const mkGolemArgs = (_sequence, container, ability) => {
    const invoker = container.getActor(ability.invokerId);
    return new ActorArgs_1.NpcActorArgs(container.getFaction(ability.invokerId), ActorType_1.ActorType.Golem, container.getLevel(ability.invokerId), Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
        const multiplier = 1;
        pet[key] = Math.round(value * multiplier);
        return pet;
    }, {}), {
        [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("Guardian").mk(),
        [enums_1.AbilitySlot.Ability2]: Registries_1.ActorAbilities.getItem("CrushingBlow").mk(),
        [enums_1.AbilitySlot.Ability3]: Registries_1.ActorAbilities.getItem("HammerSmash").mk(),
    })
        .withPlayerId(invoker.playerId)
        .withAi("BasicV2", {
        abilityPriorities: [
            {
                slot: enums_1.AbilitySlot.Ability1,
                target: "self"
            },
            {
                slot: enums_1.AbilitySlot.Ability2,
                target: "lastDamagedBy"
            },
            {
                slot: enums_1.AbilitySlot.Ability2,
                target: "lowestHealth"
            }
        ]
    });
};
let DropTheHammerActorAbilityFactory = class DropTheHammerActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DropTheHammer", "AllEnemies", 3);
    }
};
DropTheHammerActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DropTheHammer")
], DropTheHammerActorAbilityFactory);
exports.DropTheHammerActorAbilityFactory = DropTheHammerActorAbilityFactory;
let DropTheHammerAbilityHandler = class DropTheHammerAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        let summonArgs = container.hasAttribute(ability.invokerId, "Charm_Sunbreaker_1") ? mkGolemArgs(sequence, container, ability)
            : mkHammerArgs(sequence, container, ability);
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                const summonedId = container.summonCompanion(sequence, ability.invokerId, summonArgs);
                container.applyBuff({
                    sequence,
                    creatorId: summonedId,
                    targetId: summonedId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.BleedImmunityEffectArgs(),
                        new core_1.LinkedEventHandlerEffectArgs("Drop the Hammer", "Heals allies for 50% of damage dealt", false, container.registerEventHandlerScript(summonedId, EventType_1.EventType.DamageDealt, Schedule_1.Schedule.Unlimited, "Effect_Leech_OnDamageDealt", {
                            percent: 50,
                            target: Target_1.Target.AllAllies
                        }))
                    ], false),
                    supernatural: true,
                    onApplied: sequence => {
                        container.applyProjectileAttacksWithDamage({
                            sequence: sequence.pushSequence("sequential"),
                            attackType: "ranged",
                            abilityKey: "ItsHammerTime",
                            attackerId: summonedId,
                            projectiles: enemies.map(enemyId => ({
                                targetId: enemyId,
                                type: "SmallBlueSpark",
                                path: (0, Random_1.randomElement)(["line", "arc"]),
                                damages: [
                                    AbilityDamage_1.AbilityDamage.Power("Holy", 70)
                                ],
                            })),
                        });
                    }
                });
            }
        });
    }
};
DropTheHammerAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DropTheHammer)
], DropTheHammerAbilityHandler);
exports.DropTheHammerAbilityHandler = DropTheHammerAbilityHandler;
